import { render, staticRenderFns } from "./SalaryAdjustmentType.vue?vue&type=template&id=1160cac8&"
import script from "./SalaryAdjustmentType.vue?vue&type=script&lang=js&"
export * from "./SalaryAdjustmentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports